module.exports = __webpack_public_path__ + "img/cross.52f0a1cf.svg";